import { render, staticRenderFns } from "./Duplicates.vue?vue&type=template&id=74e999b1&scoped=true&"
import script from "./Duplicates.vue?vue&type=script&lang=ts&"
export * from "./Duplicates.vue?vue&type=script&lang=ts&"
import style0 from "./Duplicates.vue?vue&type=style&index=0&id=74e999b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e999b1",
  null
  
)

export default component.exports